import { render } from "./MarketplaceView.vue?vue&type=template&id=4853776d"
const script = {}
script.render = render

export default script